export default {
  toggle(state) {
    state.active = !state.active
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/mutations.js